export default __webpack_public_path__ + "static/media/job2.440b5af5.svg";